var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-nav"},_vm._l((_vm.navList),function(item,index){return _c('site-nav-item',{key:("nav-item-" + index),attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }